import { ConsignmentConfigListPage } from "@/features/consignment-settlement/pages/ConsignmentConfigListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-config/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentConfigListPage,
});
